var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabEvents = function SvgTabEvents(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4189",
    width: 32,
    height: 32,
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1020.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4199",
    fill: "currentColor",
    d: "m28 1020.4-12 12h10.667l-21.333 20 8.533-16H4.001l10.667-16z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabEvents);
export default ForwardRef;